// Which strategy the Monitor/Backtest tabs are currently looking at. Decoupled from
// the Strategies list so navigating between tabs doesn't lose context.

import { createContext, useContext, useState, type ReactNode } from "react";

interface SelectedStrategyContextValue {
  selectedStrategyId: string | null;
  setSelectedStrategyId: (id: string | null) => void;
}

const SelectedStrategyContext = createContext<SelectedStrategyContextValue | null>(null);

export function SelectedStrategyProvider({ children }: { children: ReactNode }) {
  const [selectedStrategyId, setSelectedStrategyId] = useState<string | null>(null);
  return (
    <SelectedStrategyContext.Provider value={{ selectedStrategyId, setSelectedStrategyId }}>
      {children}
    </SelectedStrategyContext.Provider>
  );
}

export function useSelectedStrategy(): SelectedStrategyContextValue {
  const ctx = useContext(SelectedStrategyContext);
  if (!ctx) throw new Error("useSelectedStrategy must be used inside SelectedStrategyProvider");
  return ctx;
}
